import {
  PayNowAuthorizationFailure,
  PayNowAuthorizationSuccess,
  PayNowOAuthCallbackParams,
} from '../types/payNowStatus'

const payNowOAuthScopes: PayNowAuthorizationSuccess['scope'][] = ['read_only', 'read_write']

const parseScope = (value: string | undefined): PayNowAuthorizationSuccess['scope'] | undefined =>
  payNowOAuthScopes.find((scope) => scope === value)

export const parsePayNowOAuthCallbackParams = (search: string): PayNowOAuthCallbackParams => {
  const params = Object.fromEntries(
    Array.from(new URLSearchParams(search).entries()).filter(([, value]) => value !== ''),
  )

  if (params.error) {
    const authorizationFailure: PayNowAuthorizationFailure = { error: params.error }
    if (params.error_description) {
      authorizationFailure.errorDescription = params.error_description
    }
    if (params.state) {
      authorizationFailure.state = params.state
    }

    return { authorizationFailure }
  }

  if (params.code) {
    const authorizationSuccess: PayNowAuthorizationSuccess = { code: params.code }
    const scope = parseScope(params.scope)
    if (scope) {
      authorizationSuccess.scope = scope
    }
    if (params.state) {
      authorizationSuccess.state = params.state
    }

    return { authorizationSuccess }
  }

  return {}
}
